import { ColumnDefinition, PivotConfig } from '../../models';

export const PIVOT_SUBTOTAL_FIELD = 'pivot_subtotal';

export interface RowGroup {
  key: string;
  firstRow: any;
  rows: any[];
  subtotal?: any;
}

export interface ColumnGroupSpan {
  group: string;
  span: number;
}

// Rows are grouped by every pivot row up to and including subtotalBy, matching the connector.
export const getSubtotalRowFields = (pivot?: PivotConfig): string[] => {
  if (!pivot?.subtotalBy) return [];
  const subtotalIndex = pivot.rows.indexOf(pivot.subtotalBy);
  return pivot.rows.slice(0, subtotalIndex + 1);
};

// The connector sorts each group's rows together with its subtotal last, so grouping is sequential.
export const groupPivotRows = (data: any[], fields: string[]): RowGroup[] =>
  data.reduce<RowGroup[]>((groups, row) => {
    const key = JSON.stringify(fields.map(field => row[field]));
    let group = groups[groups.length - 1];
    if (!group || group.key !== key) {
      group = { key, firstRow: row, rows: [] };
      groups.push(group);
    }
    if (row[PIVOT_SUBTOTAL_FIELD]) {
      group.subtotal = row;
    } else {
      group.rows.push(row);
    }
    return groups;
  }, []);

export const spanColumnGroups = (
  columns: ColumnDefinition[]
): ColumnGroupSpan[] =>
  columns.reduce<ColumnGroupSpan[]>((spans, column) => {
    const group = column.group ?? '';
    const last = spans[spans.length - 1];
    if (last && last.group === group) {
      last.span += 1;
    } else {
      spans.push({ group, span: 1 });
    }
    return spans;
  }, []);

// Flags columns where the column group changes, so each group's span gets a visible left edge.
export const markColumnGroupStarts = (
  columns: ColumnDefinition[]
): ColumnDefinition[] =>
  columns.map((column, index) => ({
    ...column,
    groupStart: index > 0 && (column.group ?? '') !== (columns[index - 1].group ?? ''),
  }));
